import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const slides = [{
  image: 'https://cdn.magicpatterns.com/uploads/1SZSvCSrs3c7zQvTtaL2MB/ChatGPT_Image_23_mar_2026,_17_23_33.png',
  title: 'Lo que vas a aprender dentro del curso',
  description: '👉 De 0 a tu primera venta\n👉 Y cómo escalar para generar ingresos reales'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/rgi4d3Wf72YgBCN8cPgKJB/ChatGPT_Image_23_mar_2026,_16_34_24.png',
  title: 'Definí tu punto de partida',
  description: 'Descubrí exactamente dónde estás y qué pasos seguir para empezar bien.\n\nCómo empezar desde cero y qué modelo elegir según tu perfil.\n\nDescubrí qué tipo de negocio se adapta a vos, tu tiempo y tus habilidades.\n\nNo todos los modelos son para todos. 👉 Encontrá el que mejor funciona para vos.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/mXCZ4kCsy2P3n4QCWwgcbK/ChatGPT_Image_23_mar_2026,_16_53_03.png',
  title: 'Usar herramientas adecuadas',
  description: 'Las herramientas justas para empezar sin complicarte ni gastar de más.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/ifrw9cBfSRNjyyQQsKwkwN/ChatGPT_Image_23_mar_2026,_16_57_16.png',
  title: 'El Montaje Secreto',
  description: 'Producto y Tienda Ganadora — Aprende a encontrar productos ganadores y montar tu tienda optimizada para conversión.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/kWSktpzh8hCjbSy6aaPGYS/ChatGPT_Image_23_mar_2026,_17_00_40.png',
  title: 'Estrategia de Publicidad en Meta',
  description: 'Domina el administrador de anuncios y crea campañas rentables desde el primer día con estructuras probadas.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/cNZqQYopexRrwBQnHmYg2K/ChatGPT_Image_23_mar_2026,_17_03_11.png',
  title: 'Escalado y Optimización',
  description: 'Aprende a leer las métricas clave y escalar tus campañas ganadoras sin perder rentabilidad en el proceso.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/x2WY8qtTmbZAJMbzd56LPk/ChatGPT_Image_23_mar_2026,_17_07_00.png',
  title: 'Copywriting que Vende',
  description: 'Estructuras de textos persuasivos y creativos que captan la atención y convierten clics en compradores reales.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/gLpCs6s6717DjEgiPrvPok/ChatGPT_Image_23_mar_2026,_17_09_33.png',
  title: 'Análisis de Métricas',
  description: 'Toma decisiones basadas en datos. Entiende qué números importan realmente para la salud de tu negocio.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/cNpUzLo6VT9XkbRw6tiDbe/ChatGPT_Image_23_mar_2026,_17_12_07.png',
  title: 'Automatización y Escala',
  description: 'Sistematiza tu tienda para que funcione en piloto automático mientras te enfocas en seguir creciendo.'
}];
export function CourseContentSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const nextSlide = () => {
    setCurrentIndex(prev => prev === slides.length - 1 ? 0 : prev + 1);
  };
  const prevSlide = () => {
    setCurrentIndex(prev => prev === 0 ? slides.length - 1 : prev - 1);
  };
  return <section className="w-full bg-brand-bg pt-6 md:pt-8 pb-8 md:pb-10 px-6 overflow-hidden" data-id="element-139">
      <div className="max-w-4xl mx-auto" data-id="element-140">
        {/* Title above card */}
        <motion.div className="text-center mb-14" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-141"></motion.div>

        {/* Heading Bar */}

        {/* Carousel Container */}
        <motion.div className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-xl relative" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        ease: 'easeOut',
        delay: 0.2
      }} data-id="element-142">
          {/* Image Track */}
          <div className="relative w-full aspect-square md:aspect-[4/3] bg-gray-50 overflow-hidden group" data-id="element-143">
            <div className="flex w-full h-full transition-transform duration-500 ease-in-out" style={{
            transform: `translateX(-${currentIndex * 100}%)`
          }} data-id="element-144">
              {slides.map((slide, index) => <div key={index} className="w-full h-full flex-shrink-0 relative" data-id="element-145">
                  {slide.image ? <img src={slide.image} alt={slide.title} className="w-full h-full object-contain p-2" data-id="element-146" /> : <div className="w-full h-full bg-gradient-to-br from-gray-100 via-white to-brand-green/5 flex items-center justify-center p-8 text-center" data-id="element-147">
                      <h3 className="text-3xl md:text-5xl font-bold text-gray-200" data-id="element-148">
                        {slide.title}
                      </h3>
                    </div>}
                  {/* Overlay gradient for text readability if needed */}
                </div>)}
            </div>

            {/* Navigation Arrows */}
            <button onClick={prevSlide} className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/90 border border-gray-200 text-gray-900 flex items-center justify-center hover:bg-brand-green hover:text-white hover:border-brand-green shadow-sm transition-all duration-200 z-10 backdrop-blur-sm" aria-label="Anterior" data-id="element-149">
              <ChevronLeftIcon className="w-6 h-6" data-id="element-150" />
            </button>
            <button onClick={nextSlide} className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/90 border border-gray-200 text-gray-900 flex items-center justify-center hover:bg-brand-green hover:text-white hover:border-brand-green shadow-sm transition-all duration-200 z-10 backdrop-blur-sm" aria-label="Siguiente" data-id="element-151">
              <ChevronRightIcon className="w-6 h-6" data-id="element-152" />
            </button>
          </div>

          {/* Description Area */}
          <div className="p-6 md:p-8 pb-16 md:pb-20 min-h-[200px] flex flex-col justify-center relative" data-id="element-153">
            {/* Scrollbar-like accent line on the right */}
            <div className="absolute right-6 top-6 bottom-6 w-1 bg-gray-200 rounded-full overflow-hidden hidden md:block" data-id="element-154">
              <div className="w-full bg-brand-green/50 transition-all duration-500" style={{
              height: `${100 / slides.length}%`,
              transform: `translateY(${currentIndex * 100}%)`
            }} data-id="element-155" />
            </div>

            <div className="md:pr-12" data-id="element-156">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3" data-id="element-157">
                {slides[currentIndex].title}
              </h3>
              <p className="text-gray-600 leading-relaxed whitespace-pre-line" data-id="element-158">
                {slides[currentIndex].description}
              </p>
            </div>
          </div>

          {/* Dot Indicators */}
          <div className="absolute bottom-6 left-0 right-0 flex justify-center items-center gap-2 z-10" data-id="element-159">
            {slides.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`h-1.5 rounded-full transition-all duration-300 ${currentIndex === index ? 'w-6 bg-brand-green' : 'w-4 bg-brand-green/20 hover:bg-brand-green/40'}`} aria-label={`Ir a la diapositiva ${index + 1}`} data-id="element-160" />)}
          </div>
        </motion.div>
      </div>
    </section>;
}